export default "__VITE_ASSET__aAEYJtsz__"